import * as z from 'zod';

export const deletedBookings = z.object({
    bookingCount: z.number().int().positive(),
});

export type DeletedBookings = z.infer<typeof deletedBookings>;
